import type { Theme } from '@mui/material';

export const usapokApprovalPageStyles = {
  callout: (theme: Theme) => ({
    width: '100%',
    maxWidth: 720,
    boxSizing: 'border-box',
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: theme.spacing(1),
    backgroundColor: theme.palette.primary['200'] ?? '#D7EBFF',
    padding: theme.spacing(2),
  }),
  content: (theme: Theme) => ({
    color: theme.palette.text.primary,
    fontSize: theme.typography.pxToRem(18),
    fontWeight: 500,
    lineHeight: 1.5,
  }),
} as const;
